
import classes from './Footer.module.scss';

const Footer = () => {

  const scrollToSection = (e) => {
    e.preventDefault();
  
    const linkSection = document.getElementById("home");
    linkSection && linkSection.scrollIntoView({ behavior: "smooth", block: "start"});
  }

  return (
    <footer className={classes.footer}>
      <div className="container">
        <p>Copyright &copy; 2022 Marvin Jayson Baga.All rights reserved.</p>
        <a href="/" className={classes.logolink} onClick={scrollToSection}>
          <i className="icon icon-logo">
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
          <span className="sr-only">mjbaga.tech</span>
        </a>
      </div>
      <div className="container">
        <div className={classes.credits}>
          <a href="https://www.freepik.com/vectors/background">Background vector created by freepik - www.freepik.com</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer;